import React, { useState, useEffect } from "react";
import { app, FrameContexts } from "@microsoft/teams-js";
import { Button, FluentProvider, webLightTheme } from '@fluentui/react-components';
import { CustomDropdown } from '../components/CustomDropdown';
import "../styles/TranscriptConsent.scss";

const AiNotEnabledScene = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      await app.initialize();
      try {
        const context = await app.getContext();

        if (context.page.frameContext !== FrameContexts.sidePanel) {
          setReady(false);
          return;
        }

        setReady(true);
      } catch (error) {
        setReady(false);
      }
    };

    initializeApp();
  }, []);

  if (!ready) {
    return (
      <div style={{ padding: "16px" }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <FluentProvider theme={webLightTheme}>
      <div style={{ display: "flex", flexDirection: "column", height: "90vh", padding: "16px" }}>
        <div style={{ marginTop: "16px" }}>
          <h4>Health Partners Transcript Assistant</h4>
        </div>

        <div style={{ marginTop: "24px" }}>
          <p>The patients organisation does not allow AI transcription so this app can not be used.</p>
        </div>
      </div>
    </FluentProvider>
  );
};

export default AiNotEnabledScene;
